import { Button, Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./login.css";

interface LoginFormProps {
  loading: boolean;
  onSubmit: (values: Record<string, any>) => void;
  onResetPassword: (value: React.SetStateAction<boolean>) => void;
}

type FieldType = {
  username?: string;
  password?: string;
  remember?: string;
};

export function LoginForm({
  loading,
  onSubmit,
  onResetPassword,
}: LoginFormProps) {
  const { t } = useTranslation();

  return (
    <Form
      name="basic"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      className="login-form-container"
      initialValues={{ remember: true }}
      onFinish={(values) => onSubmit(values)}
      autoComplete="off"
      requiredMark={false}
    >
      <img
        className="header-image"
        src="/assets/CM1-icon-white-small.png"
        alt="CM1Logo"
      />
      <Form.Item<FieldType>
        label={<span className="form-label">{t("login:email-address")}</span>}
        name="username"
        style={{ color: "white" }}
        rules={[{ required: true, message: t("login:email-validation-error") }]}
      >
        <Input style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item<FieldType>
        label={<span className="form-label">{t("login:password")}</span>}
        name="password"
        style={{ color: "white" }}
        rules={[
          { required: true, message: t("login:password-validation-error") },
        ]}
      >
        <Input.Password style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item>
        <span
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => onResetPassword(true)}
        >
          <i>{t("login:password-reset")}</i>
        </span>
      </Form.Item>
      <Form.Item label={null}>
        <Button
          type="primary"
          loading={loading}
          htmlType="submit"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "15px",
            height: "40px",
          }}
        >
          <span style={{ color: "white", fontSize: "16px" }}>Login</span>
        </Button>
      </Form.Item>
    </Form>
  );
}
